import { render } from "./CreateVpc.vue?vue&type=template&id=b0b29982&scoped=true"
import script from "./CreateVpc.vue?vue&type=script&lang=js"
export * from "./CreateVpc.vue?vue&type=script&lang=js"

import "./CreateVpc.vue?vue&type=style&index=0&id=b0b29982&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0b29982"]])

export default __exports__